const colors = {
  grey: {
    '000': '#ffffff',
    '50': '#FAFAFC',
    '100': '#f5f5f9',
    '150': '#EEEEF2',
    '200': '#e6e6ea',
    '300': '#b6b6c0',
    '500': '#868696',
    '600': '#56566B',
    '650': '#4A4A61',
    '700': '#3d3d57',
    '750': '#31314B',
    '800': '#25253f',
    '900': '#0d0d28',
  },
  blue: {
    '100': '#f3fbfe',
    '200': '#cceffc',
    '300': '#82d4f2',
    '500': '#00abe8',
    '700': '#0089c7',
    '900': '#005992',
  },
  codeBlue: {
    '500': '#00AAB4',
  },
  pink: {
    '100': '#FCE6EF',
    '300': '#f26aa6',
    '500': '#d82071',
    '700': '#8a003c',
    '900': '#6d0030',
  },
  yellow: {
    '100': '#FFF8E9',
    '200': '#FFECBE',
    '300': '#ffd7a2',
    '500': '#ffbf26',
    '700': '#f0aa00',
    '900': '#bf8700',
  },
  k8sBlue: {
    '300': '#9bacfd',
    '500': '#3e5ff5',
    '700': '#011ea4',
    '900': '#001782',
  },
  red: {
    '100': '#FFECE9',
    '300': '#ff9f8e',
    '500': '#ff4826',
    '700': '#f02500',
    '900': '#bf1e00',
  },
  green: {
    '100': '#E5F2EA',
    '300': '#B3D8C2',
    '500': '#007D33',
  },
  orange: {
    '100': '#FFF3E5',
    '500': '#ff8a00',
  },
  aws: {
    300: '#FFB74D',
    500: '#FF9800',
    700: '#F57C00',
  },
  azure: {
    300: '#AEE0FF',
    500: '#4AA3DF',
    700: '#1E699C',
  },
  googleYellow: {
    500: '#F4B400',
  },
}
export default colors
